import { concat } from 'lodash';
import React, { FC } from 'react';
import CreateForm from 'src/components/ui-component/form-component/create-form/CreateForm';
import { useApplication } from 'src/context/ApplicationContext';
import { ALS_ERLEDIGT_MARKIEREN_LABEL, PLATZHALTER_TEXT } from 'src/lib/constants/constant';
import { FormStrucItem } from 'src/lib/types/types';
import { ForceTrue } from 'src/lib/validation/ValidationTypes';
import { checkReadOnlyInUeberarbeitung } from 'src/utils/helper';
import PruefAssistenz from '../../../../../antrag-components/PruefAssistenz';
import ApplicationHeading from '../../../../../application-heading/ApplicationHeading';
import { checkIfPruefAssitenzNeedsToValidate } from '../../../../../application-helper-function/AppHelperfunctions';

// import schemas
import AntragSchema from 'src/lib/paths/antrag_FULL_Paths.json';
const P = AntragSchema.attributes;

const BegruendungAntragMobilitaetsplaeneCommon: FC<{ hasComment?: boolean }> = ({ hasComment }) => {
	const { application, setApplicationProperty, readOnly } = useApplication();
	const updatedReadOnly = checkReadOnlyInUeberarbeitung(application, readOnly, hasComment);
	return (
		<>
			<ApplicationHeading title='Begründung zur Notwendigkeit und Angemessenheit der beantragten Förderung' description={PLATZHALTER_TEXT} />

			<PruefAssistenz
				statusPath={P.Projektbeschreibung_Mobilitaetsplaene.schema.attributes.Pruefung_Notwendigkeit_Pruefstatus.path}
				hinweisPath={P.Projektbeschreibung_Mobilitaetsplaene.schema.attributes.Pruefung_Notwendigkeit_Hinweis_Fuer_Den_Antragsteller.path}
				ueberarbeitetAmPath={P.Projektbeschreibung_Mobilitaetsplaene.schema.attributes.Pruefung_Notwendigkeit_Ueberarbeitet_Am.path}
				erledigtPath={P.Projektbeschreibung_Mobilitaetsplaene.schema.attributes.Pruefung_Notwendigkeit_Erledigt.path}
				formStruc={formStrucPruefAssistenz()}
			/>

			<CreateForm formStruc={formStruc()} formValues={application} updateFormValuesFunc={setApplicationProperty} readOnly={updatedReadOnly} />
		</>
	);
};

export default BegruendungAntragMobilitaetsplaeneCommon;

const formStrucPruefAssistenz = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...P.Projektbeschreibung_Mobilitaetsplaene.schema.attributes.Pruefung_Notwendigkeit_Erledigt,
					label: ALS_ERLEDIGT_MARKIEREN_LABEL,
					validation: [{ validateFunction: ForceTrue }],
				},
			],
		},
	];
	return struc;
};

const formStruc = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [P.Projektbeschreibung_Mobilitaetsplaene.schema.attributes.Projektbeschreibung_Mobi_0223454964_egruendung_Zur_Notwendigkeit],
			userProps: { columnToDivide: 1 },
		},
	];
	return struc;
};

export const getFormStrucBegruendungAntragMobilitaetsplaeneCommon = (application: any) => {
	if (
		checkIfPruefAssitenzNeedsToValidate(
			application,
			P.Projektbeschreibung_Mobilitaetsplaene.schema.attributes.Pruefung_Notwendigkeit_Pruefstatus.path,
			P.Projektbeschreibung_Mobilitaetsplaene.schema.attributes.Pruefung_Notwendigkeit_Erledigt.path,
		)
	)
		return concat(formStrucPruefAssistenz(), formStruc());
	return concat(formStruc());
};
